import { get, httpDelete, patch, post } from '../../utils/http';

export const addShift = ({ accountId, branchId, projectId, values }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts`, values);

export const updateShift = ({ accountId, branchId, projectId, shiftId, isOverbooking }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}`, {
    isOverbooking
  });

export const fetchShiftApplicationsHistory = ({ accountId, branchId, projectId, shiftId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/applications-history`);

export const fetchSearchAvailableEmployees = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  name,
  info,
  pageSize,
  token,
  filterByPositions = false,
  filters,
  showOnlyNewEmployees = false
}) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/availability`, {
    name,
    info,
    pageSize,
    page: token || 0,
    kinds: ['available', 'applied', 'other', 'applied-rejection', 'available-rejection'],
    warnings: true,
    filterByPositions,
    filters,
    showOnlyNewEmployees
  });

export const updateEmployeeApplication = ({ accountId, branchId, projectId, shiftId, employeeId, data }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/employees/${employeeId}`, {
    ...data
  });

export const updateShiftRegistration = ({
  accountId,
  branchId,
  projectId,
  isPaused,
  publicationId,
  shiftId,
  message
}) =>
  patch(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/registration`, {
    isPaused,
    publicationId,
    message
  });

export const shareShiftToSocial = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  sharedDataKeys,
  additionalInformation,
  specialRequirements
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/social-share`, {
    sharedDataKeys,
    additionalInformation,
    specialRequirements
  });

export const updateShiftUnbooking = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  unbookingId,
  unbookReasonId,
  notes,
  isSick,
  accountLeaveTypeId,
  hoursSource,
  wageSource,
  includeShiftPayrollFields,
  unbookConflictingShifts,
  overrideInsufficientBalance,
  overrideEarningsLimit
}) =>
  patch(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/unbookings/${unbookingId}`,
    {
      unbookReasonId,
      notes,
      isSick,
      accountLeaveTypeId,
      hoursSource,
      wageSource,
      includeShiftPayrollFields,
      unbookConflictingShifts,
      overrideInsufficientBalance,
      overrideEarningsLimit
    }
  );

export const createNewChangeToShifts = ({
  accountId,
  branchId,
  projectId,
  shifts,
  isExternal,
  directSupplierProjectId
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/create-change-shifts`, {
    shifts,
    isExternal,
    directSupplierProjectId
  });

export const initiateOrderChangeUponShiftsChange = ({ accountId, branchId, projectId, shifts }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/orders-bulk-change`, {
    shifts
  });

export const updateProjectShiftsHours = ({
  accountId,
  branchId,
  projectId,
  minutes,
  offsetTarget,
  startTime,
  endTime,
  shiftIds,
  createOrderChangeBulk = false,
  notifyEmployeesUponChange = false
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/shiftHours`, {
    minutes,
    offsetTarget,
    shiftIds,
    startTime,
    endTime,
    createOrderChangeBulk,
    notifyEmployeesUponChange
  });

export const removeSchedule = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  slotId,
  isSoftDelete,
  push,
  message,
  notes,
  addUnbooking,
  markAsOpenShift,
  decreaseNeeded,
  unbookReasonId,
  unbookFromEntireEvent,
  unbookFromLinkedShifts,
  bypassComplianceWarnings,
  accountLeaveTypeId,
  hoursSource,
  wageSource,
  includeShiftPayrollFields,
  unbookConflictingShifts,
  overrideInsufficientBalance,
  overrideEarningsLimit
}) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/booking`, {
    slotId,
    isSoftDelete,
    push,
    message,
    addUnbooking,
    markAsOpenShift,
    decreaseNeeded,
    unbookReasonId,
    notes,
    unbookFromEntireEvent,
    unbookFromLinkedShifts,
    bypassComplianceWarnings,
    accountLeaveTypeId,
    hoursSource,
    wageSource,
    includeShiftPayrollFields,
    unbookConflictingShifts,
    overrideInsufficientBalance,
    overrideEarningsLimit
  });

export const deleteProjectsShiftsInRange = ({ accountId, branchId, from, to }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/shifts`, { from, to });

export const deleteEmployeeApplication = ({
  accountId,
  branchId,
  employeeIds,
  projectId,
  shiftId,
  withNotification,
  message = undefined
}) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/employees`, {
    employeeIds,
    withNotification,
    message
  });

export const shiftAvailabilityRelease = ({ accountId, branchId, projectId, shiftId, message, employeeIds }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/releaseEmployees`, {
    message,
    employeeIds
  });
